module.exports = __webpack_public_path__ + "static/media/chapter_number_3.5e2ec07e.svg";